import React from 'react';
import styled from 'styled-components';

import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';

import * as S from './styles';

export type BreadcrumbPath = {
  id: string | number;
  name: string;
  pathName: string;
};

type BreadcrumbProps = {
  className?: string;
  homeText: string;
  path: BreadcrumbPath[];
  firstPathSelectable?: boolean;
};

const ArrowLeft = styled(({ mobile, ...props }) => (
  <ChevronLeftIcon {...props} />
))`
  ${S.ArrowStyles}
`;

const ArrowRight = styled(({ mobile, ...props }) => (
  <ChevronRightIcon {...props} />
))`
  ${S.ArrowStyles}
`;

const Breadcrumb = (props: BreadcrumbProps) => {
  const {
    firstPathSelectable = false,
    path = [],
    className = undefined,
    homeText,
  } = props;

  const renderMobile = () => {
    const length = path.length;

    const item =
      path.length <= 1
        ? { name: homeText, pathName: '/' }
        : path[firstPathSelectable ? length - 1 : length - 2];

    return (
      <S.Breadcrumbs mobile data-test="Breadcrumbs" className={className}>
        <S.Crumb to={item.pathName} data-test-path={item.pathName}>
          <ArrowLeft mobile />
          <S.Ellipsis>{item.name}</S.Ellipsis>
        </S.Crumb>
      </S.Breadcrumbs>
    );
  };

  const renderDesktop = () => {
    return (
      <S.Breadcrumbs desktop data-test="Breadcrumbs" className={className}>
        <S.Crumb to="/">{homeText}</S.Crumb>

        {path.map((p, index) => (
          <React.Fragment key={p.name}>
            <ArrowRight />

            {(index !== path.length - 1 || firstPathSelectable) && (
              <S.Crumb to={p.pathName} data-test-path={p.pathName}>
                <S.Ellipsis title={p.name}>{p.name}</S.Ellipsis>
              </S.Crumb>
            )}

            {index === path.length - 1 && !firstPathSelectable && (
              <S.Current data-test-path={p.pathName}>
                <S.Ellipsis title={p.name}>{p.name}</S.Ellipsis>
              </S.Current>
            )}
          </React.Fragment>
        ))}
      </S.Breadcrumbs>
    );
  };

  return (
    <>
      {renderMobile()}
      {renderDesktop()}
    </>
  );
};

export default Breadcrumb;
